<template>
    <div @click="routerPush" :class="{detailTo: imageNumber !== 0}">
        <div v-if="tab === '大图'" class="detail-big-img" @click="logIndexImg">
            <img
                src="@/assets/images/bitmap-small.png"
                v-real-src="imgSrc"
            />
            <p v-if="imageNumber > 0" class="detail-img-num">
                <span>查看全部{{imageNumber}}张图</span>
                <img src="@/common/images/car-train/right-arrow-1.svg" />
            </p>
            <p v-else class="detail-img-num">
                <span>暂无外观图</span>
            </p>
        </div>
        <div v-else class="detail-img-more-name" @click="logIndexImg">
            <p class="vertical-letter">
                <span>{{tab}}</span>
            </p>
            <img
                src="@/assets/images/bitmap-small.png"
                v-real-src="imgSrc"
            />
        </div>
    </div>
</template>
<script>
/**
 * @file
 * @author
 */
import {sendLog} from 'js/log';
import {openUrlInNewTab} from '@/common/js/core';

export default {
    props: {
        imgSrc: String,
        tab: String,
        carSeriesInfo: Object,
        imageNumber: Number
    },
    methods: {
        logIndexImg() {
            const {
                name = '',
                brandName = '',
                id = ''
            } = this.carSeriesInfo || {};
            sendLog('car_train_index_image_click', {
                tab: this.tab,
                name,
                brandName,
                seriesId: id
            });
        },
        routerPush() {
            if (this.imageNumber !== 0) {
                openUrlInNewTab({
                    name: 'IMAGE_LIST',
                    query: {
                        sername: this.carSeriesInfo.name,
                        tab: this.tab === '大图' ? '外观' : this.tab
                    },
                    params: {
                        serid: this.carSeriesInfo.id
                    }
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.detailTo {
    cursor: pointer;
}
.detail-big-img {
    position: relative;
    width: 396px;
    height: 264px;
    img {
        width: 100%;
        height: 100%;
    }
    .detail-img-num {
        position: absolute;
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 14px;
        padding: 5px 16px;
        bottom: 9px;
        left: 9px;
        border-radius: 12px;
        color: #ffffff;
        background: rgba(0, 0, 0, .5);
        img {
            width: 14px;
            height: 14px;
            margin-left: 6px;
            color: #ffffff;
        }
    }
}

.detail-img-more-name {
    display: flex;
    height: 82px;
    cursor: pointer;
    .vertical-letter {
        width: 24px;
        height: 100%;
        font-size: 14px;
        color: #FFFFFF;
        background: #2E2E33;
    }
    img {
        flex: 1;
        height: 100%;
    }
}
</style>
